// Resolves how the global site selector should render on a given path.
// - `hidden`   — no selector at all (sites list / create page).
// - `enabled`  — interactive (allowlisted pages, plus /sites/<uuid>/* where
//                the URL encodes the site and useSelectedSite syncs both ways).
// - `disabled` — visible but read-only (every other authed route).
export type SiteSelectorMode = 'hidden' | 'enabled' | 'disabled';

const HIDDEN_PATHS: readonly string[] = ['/sites', '/sites/create'];

const ENABLED_PATHS: readonly string[] = [
  '/alerts',
  '/configuration',
  '/dashboard',
  '/device-overview',
  '/device-health',
  '/hcp-groups',
  '/healthcare-providers',
  '/healthcare-providers/create',
  '/residents',
  '/residents/create',
];

// Site root: /sites/<uuid> exactly — switching navigates to the new site root.
const SITES_ROOT_RE = /^\/sites\/[^/]+$/;

export const getSiteSelectorMode = (pathname: string): SiteSelectorMode => {
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (HIDDEN_PATHS.includes(normalized)) return 'hidden';
  if (SITES_ROOT_RE.test(normalized)) return 'enabled';
  if (ENABLED_PATHS.includes(normalized)) return 'enabled';
  return 'disabled';
};
